<template>
  <div class="w1200" style="padding-top: 20px">
    <!-- banner区域 -->
    <div class="index_banner">
      <div class="banner_card">
        <a-menu :openKeys="openKeys" :selectedKeys="selectedKeys" style="width: 100%; height: 100%" mode="vertical"
          @select="select">
          <a-sub-menu v-for="subMenu in menuList" :key="subMenu.index" @click="goOfflineMenuList(subMenu.title)">
            <template #title>
              <span> {{ subMenu.title }}</span>
            </template>
            <a-menu-item v-for="item in subMenu.children" :key="item.name"
              @click="goEachMenuList(subMenu.title, item.name)">
              <span>{{ item.title }}</span>
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </div>
      <div class="banner_card bannerImg_card">
        <a-carousel autoplay>
          <div v-for="item in indexData.banner" :key="item.id">
            <img :src="item.thumb" alt="" style="width: 100%;cursor: pointer;" @click="goBannerLink(item.url)" />
          </div>
        </a-carousel>
      </div>
      <div class="banner_card">
        <div class="logout" v-if="userInfo == null">
          <h2>免费注册</h2>
          <h3>领取免费课程好礼</h3>
          <img src="../../assets/images/index_login.png" class="logoutBanner" alt="" />
          <a-button type="primary" @click="login" style="padding: 4px 24px;">登陆<span
              style="margin: 0 23px;">|</span>注册</a-button>
        </div>
        <div class="logining" v-else>
          <a-avatar :size="48" :src="head_img">
            <template #icon>
              <UserOutlined />
            </template>
          </a-avatar>
          <h3>{{ userInfo.name }}</h3>
          <div class="learn">
            <div class="learnTime">
              <span class="title">今日学习</span>
              <span class="time"><i>{{ studyTime.time }}</i>分钟</span>
            </div>
            <a-divider style="border-color: rgba(0, 0, 0, 0.08); margin: 16px 0" dashed />
            <div class="learnTime">
              <span class="title">累计学习</span>
              <span class="time"><i>{{ studyTime.date }}</i>天</span>
            </div>
            <div class="loginBg">
              <img src="../../assets/images/index_loginBg.png" alt="" />
            </div>
          </div>
          <a-button type="primary" block href="/myCenter/myOrder/orderTotal">进入已购</a-button>
        </div>
      </div>
    </div>
    <!-- 最新直播区域 -->
    <div class="index_live">
      <div class="title_box">
        <div class="title">最新直播</div>
        <router-link to="/liveList">
          <div class="more">
            更多直播<img src="../../assets/images/index_rightArrow1.png" class="rightArrow1" alt="" />
          </div>
        </router-link>
      </div>
      <div class="live_content">
        <a-divider class="time_line" style="height: 1px; background-color: rgba(0, 0, 0, 0.06)" />
        <div class="live_item" v-for="item in indexData.live" :key="item.id">
          <div class="live_box">
            <img src="../../assets/images/index_livepreview.png" class="live_clock" alt=""
              v-if="item.is_type == 1 || item.is_type == 2" />
            <img src="../../assets/images/index_liveing.png" alt="" class="live_clock" v-else-if="item.is_type == 3" />
            <img src="../../assets/images/index_lived.png" class="live_clock" alt="" v-else />

            <span class="live_time">{{ item.date }}</span>
          </div>
          <router-link :to="`/liveDetails?id=${item.id}`">
            <div class="live_detail">
              <div class="cover_box">
                <img :src="item.thumb" alt="" class="cover" />
                <div class="corner_mark">
                  <img src="../../assets/images/index_livepreviewBadge.png" alt=""
                    v-if="item.is_type == 1 || item.is_type == 2" />
                  <img src="../../assets/images/index_livedBadge.png" alt=""
                    v-if="item.is_type == 4 || item.is_type == 5" />
                </div>
                <div class="glass_wrap" v-if="item.is_type == 3">
                  <img src="../../assets/images/living_icon.png" alt="" class="livebtn" @click="goLive(item.id)" />
                </div>
              </div>
              <div class="detail_content">
                <h3>
                  {{ item.title }}
                </h3>
                <div class="tags">
                  <a-tag class="newTag" v-if="item.is_new == 1">新客专享</a-tag>
                  <a-tag class="vipTag" v-if="item.is_member == 1">会员专享</a-tag>
                </div>
                <div class="apply_box">
                  <div class="price">
                    <span class="cost">￥{{ item.price_selling }}</span>
                    <span class="original" v-if="item.price_selling != ''">￥{{ item.price_market }}</span>
                  </div>
                  <span class="num">{{ item.applicant_num }}人已报名</span>
                </div>

                <a-button type="primary" block v-if="item.is_type == 1" @click="goLive(item.id)">
                  <span>立即预约</span>
                </a-button>
                <a-button type="primary" block class="success-btn" v-else-if="item.is_type == 2"
                  @click="goLive(item.id)">
                  <span>预约成功</span>
                </a-button>
                <a-button type="primary" block class="success-btn" v-else-if="item.is_type == 3"
                  @click="goLive(item.id)">
                  <span>进入直播</span>
                </a-button>
                <a-button type="primary" block v-else-if="item.is_type == 4" @click="goLive(item.id)">
                  <span>查看回放</span>
                </a-button>
                <a-button type="primary" block :disabled="true" v-else>
                  <span>暂无回放</span>
                </a-button>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <a-carousel autoplay>
      <a class="YCBanner1" href="https://dwz.cn/sYa4H6zG" target="_blank">
        <img src="@/assets/images/YC_Link01.jpeg" alt="" />
      </a>
      <a class="YCBanner1" href="https://yinocloud.yinolink.com/register?source=fridayMbanner" target="_blank">
        <img src="@/assets/images/YC_Link01.svg" alt="" />
      </a>
    </a-carousel>

    <!-- 海外营销服务 -->
    <div class="index_live">
      <div class="title_box">
        <div class="title">海外营销服务</div>
        <router-link to="/serviceList">
          <div class="more">
            更多服务<img src="../../assets/images/index_rightArrow1.png" class="rightArrow1" alt="" />
          </div>
        </router-link>
      </div>
      <div class="live_content" style="justify-content: flex-start;gap:54px;">
        <div class="live_item" v-for="item in indexData.markets" :key="item.id">
          <router-link :to="`/serviceDetails?id=${item.id}`">
            <div class="live_detail">
              <div class="cover_box">
                <img :src="item.thumb" alt="" class="cover" />
              </div>
              <div class="detail_content">
                <h3 style="height: 78px;">
                  {{ item.title }}
                </h3>
                <div class="apply_box">
                  <span class="type">{{ item.price }}</span>
                  <span class="num">{{ item.applicant_num }}人已报名</span>
                </div>
                <a-button type="primary" block style="background-color: #FAAD14;border: none;">
                  <span>查看详情</span>
                </a-button>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <!-- 海外营销知识 -->
    <div class="index_knowledge">
      <div class="title_box">
        <div class="title">海外营销知识</div>
      </div>
      <swiper :modules="modules" :slides-per-view="3" :space-between="58" @swiper="onSwiper"
        @slideChange="onSlideChange">
        <swiper-slide v-for="item in indexData.course" :key="item.id">
          <div class="knowledge_item">
            <div class="item_header">
              <div class="head_title">
                <img :src="item.icon" alt="" />
                <span>{{ item.title }}</span>
              </div>
              <div class="more" @click="goMKMore(item.title)">
                查看更多<img src="../../assets/images/index_rightArrow1.png" class="rightArrow1" alt="" />
              </div>
            </div>
            <div class="item_body">
              <div class="eachMK" v-for="(list, index) in item.detail" :key="list.index"
                @click="goEachList(list.type, list.id)">
                <div class="article_cover" v-if="index == 0">
                  <img :src="list.thumb" alt="" class="cover" />
                  <div class="cover_content">
                    <div class="title" :title="list.title">{{ list.title }}</div>
                    <div class="content">
                      {{ list.description }}
                    </div>
                  </div>
                </div>
                <div class="article_link" v-else>
                  <router-link to="/">
                    <div class="link_item">
                      <img src="../../assets/images/index_linkvideo.png" alt=""
                        v-if="list.type == 'live' || list.type == 'course'" />
                      <img src="../../assets/images/index_linkbook.png" alt=""
                        v-if="list.type == 'blog' || list.type == 'white-book'" />
                      <img src="../../assets/images/index_link.png" alt="" v-if="list.type == 'offline'" />
                      <div class="title" :title="list.title">
                        {{ list.title }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="knowledge_slogan">
        <div class="slogan_item" v-for="item in slogan_item" :key="item.id" @click="goWhiteBookList(item.id)">
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>
    <!-- 线下活动 -->
    <div class="index_offline">
      <div class="title_box">
        <div class="title">线下活动</div>
      </div>
      <div class="offline_content">
        <div class="img_box">
          <div class="left_box hoverItem">
            <router-link :to="`/offLineDetails?id=${offline1.id}`">
              <img :src="offline1.thumb" alt="" />
            </router-link>
          </div>
          <div class="right_box">
            <router-link :to="`/offLineDetails?id=${item.id}`" v-for="item in indexData.offline2" :key="item.id">
              <img :src="item.thumb" alt="" class="topImg hoverItem" />
            </router-link>
          </div>
        </div>
        <div class="word_box">
          <router-link :to="`/offLineDetails?id=${item.id}`" v-for="item in indexData.offline3" :key="item.id">
            <div class="article_content">
              <h3>
                <span class="tags">
                  <a-tag class="newTag" v-if="item.is_new == 1">新客专享</a-tag>
                  <a-tag class="vipTag" v-if="item.is_member == 1">会员专享</a-tag>
                </span>
                {{ item.title }}
              </h3>
              <div class="review">
                <div class="reviewLeft">
                  <span>
                    <i class="price_selling">￥{{ item.price }}</i>
                  </span>
                  <div class="time">{{ item.begin_date }}</div>
                </div>
                <div class="review_btn">
                  <a-button type="link" v-if="item.type == 0">前往报名<i class="iconfont icon-zwjinru"></i></a-button>
                  <a-button type="link" v-else-if="item.type == 1">查看详情<i class="iconfont icon-zwjinru"></i></a-button>
                  <a-button type="link" disabled v-else>暂无回顾<i class="iconfont icon-zwjinru"></i></a-button>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <a href="https://yinocloud.yinolink.com/?source=zhou5chuhai" target="_blank" class="YCBanner2">
    <img src="@/assets/images/YC_Link02.png" />
  </a>
  <a-modal title="" v-if="dialogType === 'isMobile'" v-model:visible="showDialog" width="100%" :closable="false"
    :keyboard="false" :mask-closable="false" :footer="null" wrap-class-name="dialog-full-screen"
    @ok="; (dialogType = 'isMobile'), (showDialog = true)" @cancel="; (dialogType = 'isMobile'), (showDialog = true)">
    <a-row justify="center" class="mobile_qr">
      <div class="mobile_qr_text">请扫描下方小程序二维码访问</div>
      <img class="mobile_qr_img" src="@/assets/images/mobile_qr.jpeg" />
    </a-row>
  </a-modal>
</template>

<script>
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Pagination, Autoplay } from 'swiper'
import { UserOutlined } from '@ant-design/icons-vue'
import PayPage from '@/components/details/PayPage'

export default {
  name: 'Index',
  components: {
    PayPage,
    Swiper,
    SwiperSlide,
    UserOutlined,
  },
  data() {
    return {
      userInfo: null,
      head_img: '',
      modules: [Navigation, Pagination, Autoplay],
      menuList: [
        {
          title: '行业解决方案',
          children: [
            {
              title: '电商',
              name: '电商',
            },
            {
              title: 'APP',
              name: 'APP',
            },
            {
              title: '游戏',
              name: '游戏',
            },
          ],
        },
        {
          title: '海外营销课程',
          children: [
            {
              title: 'Facebook',
              name: 'Facebook',
            },
            {
              title: 'TikTok',
              name: 'TikTok',
            },
            {
              title: 'Google',
              name: 'Google',
            },
            {
              title: 'Bing',
              name: 'Microsoft',
            },
            // {
            //   title: 'Instagram',
            //   name: 'Instagram',
            // },
          ],
        },
        {
          title: '白皮书下载',
          children: [
            {
              title: '电商',
              name: '1',
            },
            {
              title: 'APP',
              name: '2',
            },
            {
              title: '游戏',
              name: '3',
            },
          ],
        },
        {
          title: '线上直播',
          children: [
            {
              title: '投放攻略',
              name: '投放攻略',
            },
            {
              title: '政策解读',
              name: '政策解读',
            },
            {
              title: '节日营销',
              name: '节日营销',
            },
            {
              title: '营销趋势',
              name: '营销趋势',
            },
            {
              title: '案例解读',
              name: '案例解读',
            },
            {
              title: '运营指南',
              name: '运营指南',
            },
          ],
        },
        {
          title: '线下活动',
        },
      ],
      studyTime: {},
      indexData: {},
      openKeys: [this.$route.path],
      selectedKeys: [this.$route.path],
      offline1: '',
      slogan_item: [
        {
          id: 1,
          title: '10000电商类白皮书免费下载',
        },
        {
          id: 2,
          title: '50000APP/游戏营销手册免费下载',
        },
        {
          id: 11,
          title: '30000海外市场洞察免费下载',
        },
      ],
      dialogType: '',
      showDialog: false,
    }
  },
  mounted() {
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    if (this.userInfo != null) {
      this.head_img = this.userInfo.w_headimgurl
    }
    this.getIndexData()
    this.getStudyTime()
    let goUrl = this.isMobile()
    if (goUrl === 1) {
      console.log('mobile')
      this.dialogType = 'isMobile'
      this.showDialog = true

      //移动端地址
      // location = 'https://acadmin.yinolink.com/mobile/index/index'
    }

    document.getElementById('commonContent').setAttribute('style', 'padding:80px 0 0')
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      if (navigator.userAgent.match(/pad/i)) {
        flag = false
      }
      localStorage.setItem('isMobile', flag ? 1 : 0)
      let goUrl = flag ? 1 : 0
      return goUrl
    },
    async getIndexData() {
      const { data: res } = await this.$http.post('index/index')
      this.indexData = res.data
      this.offline1 = this.indexData.offline1
    },
    async getStudyTime() {
      const { data: res } = await this.$http.post('index/study')
      this.studyTime = res.data
    },
    login() {
      this.$bus.emit('openLogin')
    },
    goLive(id) {
      this.$router.push({
        name: 'LiveDetails',
        query: {
          id: id,
        },
      })
    },
    onSwiper(swiper) { },
    onSlideChange() {
      console.log('slide change')
    },
    select({ key }) {
      this.openKeys = [key]
      this.selectedKeys = [key]
    },
    // 更多海外营销知识
    goMKMore(title) {
      this.$router.push({
        name: 'SearchList',
        query: {
          title: title,
        },
      })
    },
    goEachList(type, id) {
      if (type == 'live') {
        this.$router.push({
          name: 'LiveDetails',
          query: {
            id: id,
          },
        })
      } else if (type == 'course') {
        this.$router.push({
          name: 'CourseDetails',
          query: {
            id: id,
          },
        })
      } else if (type == 'blog') {
        this.$router.push({
          name: 'MkArticleDetails',
          query: {
            id: id,
          },
        })
      } else if (type == 'white-book') {
        this.$router.push({
          name: 'WhiteBookDetails',
          query: {
            id: id,
          },
        })
      } else {
        this.$router.push({
          name: 'OffLineDetails',
          query: {
            id: id,
          },
        })
      }
    },
    goWhiteBookList(id) {
      this.$router.push({
        name: 'WhiteBookList',
        query: {
          id: id,
        },
      })
    },
    goEachMenuList(title, name) {
      console.log(name)
      if (title == '行业解决方案') {
        this.$router.push({
          name: 'MKArticleList',
          query: {
            name: name,
          },
        })
      } else if (title == '海外营销课程') {
        this.$router.push({
          name: 'MkCourseList',
          query: {
            name: name,
          },
        })
      } else if (title == '海外营销课程') {
        this.$router.push({
          name: 'MkCourseList',
          query: {
            name: name,
          },
        })
      } else if (title == '白皮书下载') {
        this.$router.push({
          name: 'WhiteBookList',
          query: {
            id: name,
          },
        })
      } else if (title == '线上直播') {
        this.$router.push({
          name: 'liveList',
          query: {
            name: name,
          },
        })
      }
    },
    goBannerLink(url) {
      if (url === '#') return
      window.open(url, '_blank')
    },
    goOfflineMenuList(title) {
      if (title == '线下活动') {
        this.$router.push('/offLineList')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.YCBanner1 {
  display: block;
  margin-bottom: 40px;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
  }
}

.YCBanner2 {
  img {
    width: 100%;
    margin-top: 40px;
  }
}

:deep(.ant-menu-submenu-arrow) {
  color: #8c8c8c;
}

.ant-menu-vertical {
  border-right: none;
}

.index_banner {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;

  .banner_card {
    width: 190px;
    height: 410px;
    background-color: #fff;
    border: none;
    border-radius: 8px;
    box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.06);
    overflow: hidden;

    .ant-menu a {
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .bannerImg_card {
    width: 780px;
  }

  :deep(.ant-menu-submenu-title) {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    height: 70px;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 70px;

    .ant-menu-title-content a {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  :deep(.ant-menu-submenu-title:hover) {
    background: #ecf9ff;

    a {
      color: #3a84ff;
    }
  }

  .logout {
    display: flex;
    flex-direction: column;
    align-items: center;

    h2 {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3A84FF;
      margin: 48px 0 20px;
    }

    h3 {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3A84FF;
      margin-bottom: 24px;
    }

    .logoutBanner {
      width: 180px;
      height: 180px;
      margin: 0 auto 16px;
    }
  }

  .logining {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 32px 16px 40px;

    h3 {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      margin: 16px 0 11px;
    }

    .learn {
      position: relative;
      width: 158px;
      height: 158px;
      padding-top: 28px;
      margin-bottom: 50px;

      .learnTime {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.65);

        .time i {
          font-size: 22px;
          color: rgba(0, 0, 0, 0.85);
          margin-right: 4px;
        }
      }

      .loginBg {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;

        img {
          width: 100%;
        }
      }
    }
  }
}

.title_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;

  .title {
    color: rgba(0, 0, 0, 0.85);
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }

  .more {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #3a84ff;
    cursor: pointer;

    .rightArrow1 {
      width: 20px;
      height: 20px;
    }
  }
}

.index_live {
  margin-bottom: 40px;

  .live_content {
    position: relative;
    display: flex;
    justify-content: space-between;

    .time_line {
      position: absolute;
    }

    .live_item {
      z-index: 1;

      .live_box {
        display: flex;
        align-items: center;
        width: 160px;
        height: 40px;
        background-color: #fff;
        box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.06);
        border-radius: 35px;
        padding: 8px 10px;
        margin: 0 auto 20px;

        .live_clock {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }

        .live_time {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
        }
      }

      .live_detail {
        position: relative;
        width: 260px;
        height: auto;
        background-color: #fff;
        border-radius: 8px;
        padding-bottom: 8px;

        // box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.06);
        .cover_box {
          position: relative;
          width: 100%;
          height: 174px;

          .cover {
            width: 100%;
            border-radius: 8px 8px 0 0;
          }

          .corner_mark {
            position: absolute;
            top: 16px;
            left: -10px;
            width: 64px;

            img {
              width: 100%;
            }
          }

          .glass_wrap {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            border-radius: 8px 8px 0 0;
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(3px);

            .livebtn {
              width: 112px;
              height: 32px;
              cursor: pointer;
            }
          }
        }

        .detail_content {
          padding: 8px 16px;

          h3 {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);
            height: 48px;
            line-height: 24px;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            margin-bottom: 0;
          }

          .tags {
            min-height: 20px;
            margin: 4px 0;
          }

          .apply_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;

            .price {
              .cost {
                font-size: 14px;
                color: #ff4d4f;
              }

              .original {
                font-size: 12px;
                color: rgba(0, 0, 0, 0.45);
                text-decoration: line-through;
              }
            }

            .type {
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.65);
              line-height: 24px;
            }

            .num {
              font-size: 12px;
              color: rgba(0, 0, 0, 0.45);
            }
          }
        }

        &:hover {
          // box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.06);
          transform: translate(0, -6px);
          box-shadow: 0 14px 36px rgba(0, 0, 0, 0.06);
          transition: all 0.5s ease;
        }
      }
    }
  }
}

.index_knowledge {
  margin-bottom: 80px;

  .knowledge_item {
    width: 360px;
    height: 290px;
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;

    .item_header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      .head_title {
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          margin-right: 6px;
        }

        span {
          font-size: 20px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.85);
        }
      }

      .more {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #3a84ff;
        cursor: pointer;

        .rightArrow1 {
          width: 20px;
          height: 20px;
        }
      }
    }

    .item_body {
      .eachMK {
        cursor: pointer;
      }

      .article_cover {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;

        .cover {
          width: 140px;
          height: 94px;
        }

        .cover_content {
          width: 160px;

          .title {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);
            margin-bottom: 16px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          .title:hover {
            color: #3a84ff;
          }

          .content {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
        }
      }

      .article_link {
        margin-bottom: 16px;

        .link_item {
          display: flex;
          align-items: center;

          img {
            width: 18px;
            height: 18px;
            margin-right: 8px;
          }

          .title {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }

        .link_item:hover {
          .title {
            color: #3a84ff;
          }
        }
      }
    }

    &:hover {
      transform: translate(0, -6px);
      box-shadow: 0 14px 36px rgba(0, 0, 0, 0.06);
      transition: all 0.5s ease;
    }
  }

  .knowledge_slogan {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;

    .slogan_item {
      position: relative;
      width: 360px;
      height: 58px;
      background: #3A84FF;
      border-radius: 8px;
      cursor: pointer;

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        white-space: nowrap;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }
}

.index_offline {
  .offline_content {
    display: flex;
    justify-content: space-between;

    .img_box {
      display: flex;
      justify-content: space-between;
      width: 754px;
      height: 333px;

      .left_box {
        width: 499px;
        height: 100%;
        background-color: #3a84ff;
        border-radius: 8px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .right_box {
        width: 235px;

        img {
          width: 100%;
          height: 157px;
          border-radius: 8px;
        }
      }
    }

    .word_box {
      width: 425px;
      height: 333px;
      padding: 16px;
      background-color: #fff;
      border-radius: 8px;

      .article_content {
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        padding-bottom: 8px;
        margin-bottom: 16px;

        h3 {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
          min-height: 48px;
          line-height: 24px;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          margin-bottom: 8px;
        }

        .review {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .reviewLeft {
            display: flex;
            align-items: center;

            span {
              font-size: 14px;
              color: rgba(0, 0, 0, 0.65);
              margin-right: 16px;

              .price_selling {
                color: #ff4d4f;
              }

              .price_market {
                text-decoration: line-through;
              }
            }

            .time {
              font-size: 14px;
              color: rgba(0, 0, 0, 0.45);
            }
          }

          .review_btn {
            .ant-btn {
              font-size: 16px;
              padding: 0;
              height: auto;
            }
          }
        }

        &:hover {
          transform: translate(12px, 0);
          transition: all 0.5s ease;
        }
      }

      a:last-child {
        .article_content {
          border-bottom: none;
          margin-bottom: 0;
        }
      }

      &:hover {
        box-shadow: 0 14px 36px rgba(0, 0, 0, 0.06);
      }
    }
  }
}

.topImg {
  margin-bottom: 20px;
}

.hoverItem:hover {
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.06);
  transform: translate(0, -6px);
  transition: all 0.5s ease;
}
</style>
<style>
.dialog-full-screen {
  padding: 0 !important;
}

.dialog-full-screen .ant-modal {
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 0 !important;
  margin: 0 !important;
}

.dialog-full-screen .ant-modal-content {
  width: 100% !important;
  height: 100% !important;
}

.dialog-full-screen .ant-modal-body {
  width: 100% !important;
  height: 50% !important;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  padding: 0 !important;
}

.dialog-full-screen .mobile_qr {
  width: 300px;
  height: 360px;
  margin: auto;
}

.dialog-full-screen .mobile_qr_text {
  font-size: 20px;
  line-height: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}

.dialog-full-screen .mobile_qr_img {
  width: 300px;
  height: 300px;
  margin-top: 20px;
}
</style>
